import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';
import getIndustryRolesConfig from './getIndustryRoles';

const actions = createActions({
  USER: {
    ADD_INDUSTRY_ROLE: (industryUser) => ({ industryUser }),
    API: {
      ADD_INDUSTRY_ROLE: apiResourceActionCreator('industryRoles')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.post(USER_RESOURCE_ENDPOINT(RESOURCES.Industries), authToken, payload, getIndustryRolesConfig.action.user.api.getIndustryRoles)

export function* addIndustryRole(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, actions.payload.industryUser));
  }
}

const configuration = {
  name: 'addIndustryRole',
  action: actions,
  sagas: addIndustryRole,
  reducers: {

  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/addIndustryRole.js